import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IMarketPositionDeal, IMarketPositionNode } from '../../types/EUMarkets.type';

export type ContractViewNewState = {
  nodes: IMarketPositionNode[];
  dealsByPositionId: Record<string, IMarketPositionDeal[]>;
  expandedKeys: string[];
};

const initialState: ContractViewNewState = {
  nodes: [],
  dealsByPositionId: {},
  expandedKeys: [],
};

const contractViewNew = createSlice({
  name: 'ContractViewNew',
  initialState,
  reducers: {
    mergeNodes: (state, action: PayloadAction<IMarketPositionNode[]>) => {
      const nodesByKey = new Map(
        state.nodes.map((node) => [`${node.nodeId}:${node.sourceId}:${node.volumeTypeId}`, node]),
      );
      action.payload.forEach((node) => {
        nodesByKey.set(`${node.nodeId}:${node.sourceId}:${node.volumeTypeId}`, node);
      });
      state.nodes = Array.from(nodesByKey.values());
    },
    setPositionDeals: (
      state,
      action: PayloadAction<{ positionId: number; deals: IMarketPositionDeal[] }>,
    ) => {
      state.dealsByPositionId[String(action.payload.positionId)] = action.payload.deals;
    },
    setExpandedKeys: (state, action: PayloadAction<string[]>) => {
      state.expandedKeys = action.payload;
    },
    clear: () => initialState,
  },
});

export const { mergeNodes, setExpandedKeys, setPositionDeals, clear } = contractViewNew.actions;
export default contractViewNew.reducer;
